import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Verify from "@/pages/Verify";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import Services from "@/pages/Services";
import Admin from "@/pages/Admin";
import PortalLayout from "@/components/PortalLayout";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground animate-pulse">
          Loading…
        </span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !["admin", "super_admin"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        element={
          <Protected>
            <PortalLayout />
          </Protected>
        }
      >
        <Route path="/portal" element={<Dashboard />} />
        <Route path="/portal/section/:section" element={<Services />} />
        <Route path="/portal/:type" element={<Library />} />
        <Route
          path="/admin"
          element={
            <Protected adminOnly>
              <Admin />
            </Protected>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/portal" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{ style: { borderRadius: 0, fontFamily: "DM Sans, sans-serif" } }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
